// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as CTABar$Showside from "./CTABar.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as Transition$Showside from "../utils/Transition.bs.js";
import * as ProductPrice$Showside from "./ProductPrice.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function PDPStickyDetails(Props) {
  var productTitle = Props.productTitle;
  var product = Props.product;
  var variant = Props.variant;
  var showOpt = Props.show;
  var imageOpt = Props.image;
  var renderSubtitle = Props.renderSubtitle;
  var onClickOpt = Props.onClick;
  var fwdRef = Props.fwdRef;
  var show = showOpt !== undefined ? showOpt : false;
  var image = imageOpt !== undefined ? imageOpt : true;
  var onClick = onClickOpt !== undefined ? onClickOpt : function (e) {};
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var imageFit = match.settings.productCardFitToContainer ? /* Contain */2 : /* Cover */1;
  var match$1 = React.useState(function () {
    return show;
  });
  var setShow = match$1[1];
  var show$1 = match$1[0];
  Belt_Option.forEach(fwdRef, function (ref) {
    ref.current = function (show) {
      Curry._1(setShow, function (param) {
        return show;
      });
    };
  });
  var match$2 = variant.media;
  var imgUrl;
  switch (match$2.TAG | 0) {
    case /* Image */0:
      imgUrl = match$2._0.url;
      break;
    case /* Video */1:
    case /* IframeEmbed */2:
      imgUrl = undefined;
      break;
  }
  var numColors = Product$Showside.getOptionsByName(product, "Color").length;
  var displayColor = numColors > 1 ? Belt_Option.getWithDefault(Product$Showside.Variant.getOptionValue(variant, "Color"), "") : "";
  var getPropertiesAsString = function (param) {
    return Belt_Array.keep([displayColor], function (i) {
      return i.trim() !== "";
    }).join(", ");
  };
  var renderDetails = function (param) {
    var tmp;
    if (image) {
      var tmp$1 = {
        fit: imageFit,
        alt: productTitle,
        priority: 1
      };
      if (imgUrl !== undefined) {
        tmp$1.src = imgUrl;
      }
      tmp = React.createElement("div", {
        className: CSS$Showside.prefix("w-full aspect-ratio-square h-0 overflow-hidden col-span-1 rounded relative bg-placeholder")
      }, React.createElement("div", {
        className: CSS$Showside.prefix("absolute inset-0")
      }, React.createElement(SmartImg$Showside.make, tmp$1)));
    } else {
      tmp = null;
    }
    return React.createElement(React.Fragment, undefined, tmp, React.createElement("div", {
      className: CSS$Showside.prefix("col-span-4 items-center w-full grid grid-cols-5")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("text-secondary text-lg col-span-3")
    }, React.createElement(DynamicTruncate$Showside.make, {
      lines: 2,
      children: productTitle
    }), React.createElement("div", {
      className: CSS$Showside.prefix("font-semibold")
    }, React.createElement(DynamicTruncate$Showside.make, {
      lines: 2,
      children: Belt_Option.mapWithDefault(renderSubtitle, getPropertiesAsString(undefined), function (fn) {
        return Curry._1(fn, undefined);
      })
    }))), React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col col-span-2 text-lg font-semibold justify-end items-end")
    }, React.createElement(ProductPrice$Showside.make, {
      at: /* PDP */0,
      product: product,
      variant: variant,
      align: /* Right */1,
      minPriceFirst: false,
      multiline: true
    }))));
  };
  return React.createElement(Transition$Showside.make, {
    show: show$1,
    unmount: false,
    enter: CSS$Showside.prefix("transition-transform transform-gpu duration-300"),
    enterFrom: CSS$Showside.prefix("translate-y-full"),
    enterTo: CSS$Showside.prefix("translate-y-0"),
    leave: CSS$Showside.prefix("transition-transform transform-gpu duration-75"),
    leaveFrom: CSS$Showside.prefix("translate-y-0"),
    leaveTo: CSS$Showside.prefix("translate-y-full"),
    className: CSS$Showside.prefix("sticky shadow-xl left-0 w-full bg-main bottom-0"),
    children: React.createElement(DataAttribute$Showside.make, {
      dataActive: show$1,
      dataTestId: "pdp-sticky-details-popup",
      children: React.createElement("div", {
        className: CSS$Showside.prefix("grid grid-cols-1 gap-4 py-4 px-6 items-center")
      }, React.createElement("div", {
        className: CSS$Showside.prefix("grid grid-cols-5 col-span-1 w-full gap-4 items-center cursor-pointer"),
        onClick: onClick
      }, renderDetails(undefined)), React.createElement(CTABar$Showside.make, {
        product: product,
        variant: variant
      }))
    })
  });
}
PDPStickyDetails.displayName = "PDPStickyDetails";
var make = PDPStickyDetails;
export { make };
/* react Not a pure module */